import AppsComponent from "../components/Online/AppsComponent";

export default function AppOnlinePage(){

    return (
        <>
        <AppsComponent/>
        </>
    )
}